export default (el) => ({
  id: String(el.hall_scheme_seat_id),
  price: Number(el.price),
});
